export const GiftContent = {
  title: {
    zh: "充的越多返得越多",
    en: "Add more, get more",
  },
  rechargeZero: {
    zh: "去充值",
    en: "Add Balance",
  },
  tipBefore: {
    zh: "充",
    en: "Add ",
  },
  tipAfter: {
    zh: "送",
    en: "Get ",
  },
  tipAfterTail: {
    zh: "",
    en: " Bonus",
  },

  chargeTip: {
    zh: "充值资金不会过期， \n充值后不可与首单折扣同时使用",
    en:
      "The recharged funds will not expire,  \nand cannot be used together with the first order discount after recharge.",
  },
  payBtnBefore: {
    zh: "用 ",
    en: "Use ",
  },
  payBtnAfter: {
    zh: " 支付 · $",
    en: " pay · $",
  },
  inputCardTip: {
    zh: "手动输入卡号",
    en: "Manually enter the card number",
  },
  agreementBefore: {
    zh: "已阅读并同意",
    en: "Agree to",
  },
  agreementAfter: {
    zh: "充值协议",
    en: "service agreement",
  },
  payMethod: {
    zh: "添加支付方式",
    en: "Add payment method",
  },
  editBtn: {
    zh: "编辑",
    en: "Edit",
  },
  savePay: {
    zh: "确认并支付 · $",
    en: "Confirm and pay · $",
  },
  applePay: {
    zh: "使用apple pay",
    en: "Use apple pay",
  },

  annualRechargeConfirm: {
    zh: ['是否确认支付', '年费？'],
    en: [`Pay `, ` 
    to active loyalty membership？`],
  },
  annualRechargeTips: {
    zh: '会员年费仅用于购买会员资格，费用不计入余额',
    en: 'Annual fee is only to purchase membership, the fee does not count towards balance'
  },
  annualRechargeDrawerTitle: {
    zh: '支付年费',
    en: ' Pay annual fee '
  }
};

export const TipContent = {
  unread: {
    zh: "请先阅读充值协议",
    en: "Please read the recharge agreement first",
  },
  unsel: {
    zh: "请先选择一项充值方案",
    en: "Please select a recharge plan first.",
  },
  payTip: {
    zh: "正在进行支付...",
    en: "Please wait ...",
  },
  errorTip: {
    zh: "创建订单失败！",
    en: "Failed to create an order!",
  },
  pubError: {
    zh: "获取 key 失败！",
    en: "Failed to get key!",
  },
  amountError: {
    zh: "支付金额无效！",
    en: "Invalid payment amount!",
  },
};

export const DialogStatus = {
  success: {
    pay: {
      zh: "支付成功",
      en: "Pay success",
    },
    payTip: {
      zh: "如账户余额未及时更新，请稍后刷新重试",
      en:
        "If the account balance is not updated in time, please refresh and try again later",
    },
  },
  annual_success: {
    pay: {
      zh: "成功加入会员 请出示会员卡以享受会员权益",
      en: "Join loyalty successfully Show your membership card to enjoy benefits",
    },
  },
  recharge_join_success: {
    pay: {
      zh: "成功加入会员 请出示会员卡以享受会员权益",
      en: "Join loyalty successfully Show your membership card to enjoy benefits",
    },

  },
  error: {
    pay: {
      zh: "支付失败",
      en: "Pay error",
    },
    payTip: {
      zh: "请稍后重新支付",
      en: "Please pay again later",
    },
  },
  confirm: {
    zh: "确认",
    en: "Confirm",
  },
  gotcha: {
    zh: "知道了",
    en: "Gotcha",
  },
};

export const getConstVal = (type: "intent" | "record") => {
  switch (type) {
    case "intent":
      return {
        data: {
          paymentId: "",
          paymentIntent: {
            id: "",
            object: "payment_intent" as const,
            amount: 0,
            canceled_at: null,
            cancellation_reason: null,
            capture_method: "",
            client_secret: "",
            confirmation_method: "",
            created: 0,
            currency: "",
            description: null,
            last_payment_error: null,
            livemode: true,
            next_action: null,
            payment_method: null,
            payment_method_types: [],
            receipt_email: null,
            setup_future_usage: null,
            shipping: null,
            status: "requires_payment_method",
          },
        },
      };
    case "record":
      return {
        result: false,
        message: "",
        data: {},
      };
    default:
      break;
  }
};
